/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestError
 */
export interface RequestError {
    /**
     * 
     */
    code?: string;
    /**
     * 
     */
    description?: string;
    /**
     * 
     */
    followup_action?: string;
    /**
     * 
     */
    location?: string;
    /**
     * 
     */
    possible_resolutions?: string;
    /**
     * 
     */
    follow_up_action_code?: string;
    /**
     * 
     */
    follow_up_action_code_definition?: string;
    /**
     * 
     */
    reason_code?: number;
    /**
     * 
     */
    reason_code_definition?: string;
    /**
     * 
     */
    valid_request?: boolean;
}

/**
 * Check if a given object implements the RequestError interface.
 */
export function instanceOfRequestError(value: object): value is RequestError {
    return true;
}

export function RequestErrorFromJSON(json: any): RequestError {
    return RequestErrorFromJSONTyped(json, false);
}

export function RequestErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestError {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'description': json['description'] == null ? undefined : json['description'],
        'followup_action': json['followup_action'] == null ? undefined : json['followup_action'],
        'location': json['location'] == null ? undefined : json['location'],
        'possible_resolutions': json['possible_resolutions'] == null ? undefined : json['possible_resolutions'],
        'follow_up_action_code': json['follow_up_action_code'] == null ? undefined : json['follow_up_action_code'],
        'follow_up_action_code_definition': json['follow_up_action_code_definition'] == null ? undefined : json['follow_up_action_code_definition'],
        'reason_code': json['reason_code'] == null ? undefined : json['reason_code'],
        'reason_code_definition': json['reason_code_definition'] == null ? undefined : json['reason_code_definition'],
        'valid_request': json['valid_request'] == null ? undefined : json['valid_request'],
    };
}

export function RequestErrorToJSON(json: any): RequestError {
    return RequestErrorToJSONTyped(json, false);
}

export function RequestErrorToJSONTyped(value?: RequestError | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'description': value['description'],
        'followup_action': value['followup_action'],
        'location': value['location'],
        'possible_resolutions': value['possible_resolutions'],
        'follow_up_action_code': value['follow_up_action_code'],
        'follow_up_action_code_definition': value['follow_up_action_code_definition'],
        'reason_code': value['reason_code'],
        'reason_code_definition': value['reason_code_definition'],
        'valid_request': value['valid_request'],
    };
}

